<template>
	<select 
		class="block w-full pl-3 pr-10 py-2 h-11 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500  rounded-md"
		:class="{
            'border-red-500 bg-red-100': hasError,
        }"
        @change="$emit('update:modelValue', $event.target.value)" 
        v-model="modelValue"
	>
		<option value="" v-if="allowEmpty">{{ placeholder ?? __('admin::forms.select') }}</option>
        <option v-for="(v, k) in options" :key="k" :value="k">{{ v }}</option>
	</select>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: [String, Number],
				default: '',
			},
			options: {
				type: Object,
				default: () => {},
			},
			allowEmpty: {
                type: Boolean,
                default: false,
            },
			hasError: {
                type: Boolean,
                default: false,
            },
            placeholder: {
            	type: String,
            	default: null,
            },
		},

		emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        },
	}
</script>